import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const rootElement = createRoot(document.getElementById("root"));

rootElement.render(<BrowserRouter><App /></BrowserRouter>);
